export default [
  {
    path: "/report-wallets-balances",
    name: "report-wallets-balances",
    meta: {
      title: "Баланс кошельков",
      authRequired: true,
    },
    component: () => import("@/modules/reports/report-wallets-balances/views/index.vue"),
  },
];
